import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import Editor from "../components/Editor";
import { Box, Grid,   Dialog, Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography, List, ListItem, InputAdornment, Select, MenuItem, 
   InputLabel, IconButton, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';

export default function EditPost() {
  const { id } = useParams();
  const [uploading, setUploading] = useState(false)

  const [redirect, setRedirect] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [postData, setPostData] = useState({
    title: '',
    summary: '',
    content: '',
    file: null,
    ingredients: [{ name: '', amount: '', unit: '' }],
    instructions: [''],
    notes: [''],
    additionalInfo: {
      prepTime: '',
      cookTime: '',
      category: '',
      method: '',
      cuisine: '',
      serving: ''
    },
    postType: '',
    visability: ''
  });

  const updatePostData = (newData) => {
    setPostData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };
  

  useEffect(() => {
    // Fetch the post data for editing
    fetch(`${process.env.REACT_APP_API_END_POINT}/blog/post/${id}`)
      .then(response => response.json())
      .then(postInfo => {
        setPostData({
          ...postData,
          title: postInfo.title,
          summary: postInfo.summary,
          content: postInfo.content,
          postType: postInfo.postType,
          visability: postInfo.visability,
          ingredients: postInfo.ingredients || [{ name: '', amount: '', unit: '' }],
          instructions: postInfo.instructions || [''],
          notes: postInfo.notes || [''],
          additionalInfo: postInfo.additionalInfo || {
            prepTime: '',
            cookTime: '',
            category: '',
            method: '',
            cuisine: '',
            serving: ''
          }
        });
      });
  }, [id]);

    // Open delete dialog
    const handleOpenDeleteDialog = () => {
      setOpenDeleteDialog(true);
    };
  
    // Close delete dialog
    const handleCloseDeleteDialog = () => {
      setOpenDeleteDialog(false);
    };

  // Handle form field changes
  const handleInputChange = (field, value) => {
    setPostData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle nested changes for additionalInfo, ingredients, etc.
  const handleNestedChange = (category, field, value) => {
    setPostData(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [field]: value
      }
    }));
  };

  async function updatePost(ev) {
    ev.preventDefault();
    setUploading(true)
    const data = new FormData();
    data.set('id', id);
    data.set('title', postData.title);
    data.set('summary', postData.summary);
    data.set('content', postData.content);
    data.set('postType', postData.postType);
    data.set('visability', postData.visability);
    data.set('category', postData.category);
    if (postData.file) {
      data.set('file', postData.file);  // Add file if uploaded
    }

    // Add recipe-related fields only if postType is "recipe"
    if (postData.postType === 'recipe') {
      data.set('ingredients', JSON.stringify(postData.ingredients));
      data.set('instructions', JSON.stringify(postData.instructions));
      data.set('notes', JSON.stringify(postData.notes));
      data.set('additionalInfo', JSON.stringify(postData.additionalInfo));
    }

    const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/blog/post`,{
      method: 'PUT',
      body: data,
      credentials: 'include',
    });

    if (response.ok) {
      setUploading(false)
      setRedirect(true);
    }
  }




  // Handle post deletion
  const deletePost = async () => {
    setUploading(true)
    const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/blog/post/${id}`,  {
      method: 'DELETE',
      credentials: 'include',
    });

    if (response.ok) {
      
      <Navigate to={'/blog'} />
      setUploading(false)
    } else {
      console.error('Failed to delete post');
    }

    handleCloseDeleteDialog(); // Close dialog after delete
    
  };

  // Add new ingredient
  const addIngredient = () => {
    updatePostData({
      ingredients: [...postData.ingredients, { name: '', amount: '', unit: '' }],
    });
  };

  // Update ingredient details
  const updateIngredient = (index, field, value) => {
    const updatedIngredients = [...postData.ingredients];
    updatedIngredients[index][field] = value;
    updatePostData({ ingredients: updatedIngredients });
  };

  // Add new instruction
  const addInstruction = () => {
    updatePostData({
      instructions: [...postData.instructions, ''],
    });
  };

  // Update instruction
  const updateInstruction = (index, value) => {
    const updatedInstructions = [...postData.instructions];
    updatedInstructions[index] = value;
    updatePostData({ instructions: updatedInstructions });
  };

  // Add new note
  const addNote = () => {
    updatePostData({
      notes: [...postData.notes, ''],
    });
  };

  // Update note
  const updateNote = (index, value) => {
    const updatedNotes = [...postData.notes];
    updatedNotes[index] = value;
    updatePostData({ notes: updatedNotes });
  };

  // Handle additional info change
  const handleAdditionalInfoChange = (field, value) => {
    updatePostData({
      additionalInfo: { ...postData.additionalInfo, [field]: value },
    });
  };

  const postCategories = (postType) => {
    if (postType === 'recipe') {
      return ['Dinner', 'Lunch', 'Breakfast', 'Brunch', 'Snacks', 'Afternoon Tea', 'Dessert', 'Appetizer'];
    } else {
      return [ 'Culinary Tips', 'Restaurant Management', 'Travel & Food'];
    }
  }

  
  if (redirect) {
    return <Navigate to={'/blog/post/' + id} />;
  }

  return (
    <Box sx={{ padding: '3% 10%' }}>
      <form onSubmit={updatePost}>
        <Grid container spacing={2} mb={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Title"
              value={postData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Sub-heading"
              value={postData.summary}
              onChange={(e) => handleInputChange('summary', e.target.value)}
              variant="outlined"
              required
            />
          </Grid>
        </Grid>

       

          {/* Image Upload */}
          <Box>
  <InputLabel>Upload Post Image</InputLabel>
  <IconButton component="label" sx={{color: '#ca7735'}}>
    <PhotoCamera className='po' />
    <input 
      type="file" 
      accept="image/*" // Restrict to images
      hidden       
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          handleInputChange('file', file);  // Use 'file' for a single file
        }
      }}
    />
  </IconButton>

  {postData.file && (
    <img 
      src={URL.createObjectURL(postData.file)} 
      alt="Uploaded" 
      style={{ width: '100%', marginTop: '1rem' }} 
    />
  )}
</Box>

        {/* Post Content */}
        <Box sx={{ marginTop: '3%', marginBottom: '5%' }}>
          <Editor
            value={postData.content}
            onChange={(newContent) => handleInputChange('content', newContent)}
          />
        </Box>

        {/* Post Visability */}
        <Box sx={{ my: '1rem', display: 'flex', justifyContent: 'start' }} gap={5}>
          <FormControl>
            <FormLabel>Post Visability</FormLabel>
            <RadioGroup
              value={postData.visability}
              onChange={(e) => handleInputChange('visability', e.target.value)}
              row
            >
              <FormControlLabel
                value="public"
                control={<Radio sx={{ color: '#ca7735', '&.Mui-checked': { color: '#ca7735' } }} />}
                label="Public"
              />
              <FormControlLabel
                value="members"
                control={<Radio sx={{ color: '#ca7735', '&.Mui-checked': { color: '#ca7735' } }} />}
                label="Member-exclusive"
              />
            </RadioGroup>
          </FormControl>

          {/* Post Type */}
          <FormControl>
            <FormLabel>Post Type</FormLabel>
            <RadioGroup
              value={postData.postType}
              onChange={(e) => handleInputChange('postType', e.target.value)}
              row
            >
              <FormControlLabel
                value="article"
                control={<Radio sx={{ color: '#ca7735', '&.Mui-checked': { color: '#ca7735' } }} />}
                label="Article"
              />
              <FormControlLabel
                value="recipe"
                control={<Radio sx={{ color: '#ca7735', '&.Mui-checked': { color: '#ca7735' } }} />}
                label="Recipe"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={{ my: '1rem', display: 'flex', justifyContent: 'start',}} gap={5}>
        <FormControl fullWidth>
          <FormLabel>Select category</FormLabel>
          <TextField
              select
              fullWidth
              variant="outlined"
               
              value={postData.category}
              onChange={(e) => handleInputChange('category', e.target.value)}
              required
            >
             {postCategories(postData.postType).map((category, index) => (
              <MenuItem fullWidth key={index} value={category}>
              {category}
              </MenuItem>
             ))}
            </TextField>
        </FormControl>
        </Box>

        {/* Show Recipe Fields Only if postType is "recipe" */}
        {postData.postType === 'recipe' && (
  <>
    {/* Ingredients Section */}
    <Typography variant="h5" gutterBottom>Key Ingredients</Typography>
    {postData.ingredients.map((ingredient, index) => (
      <Grid container spacing={2} key={index} mb={2}>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label="Ingredient Name"
            value={ingredient.name}
            onChange={(e) => {
              const updatedIngredients = [...postData.ingredients];
              updatedIngredients[index].name = e.target.value;
              handleInputChange('ingredients', updatedIngredients);
            }}
            variant="outlined"
            required
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label="Amount (optional)"
            value={ingredient.amount}
            onChange={(e) => {
              const updatedIngredients = [...postData.ingredients];
              updatedIngredients[index].amount = e.target.value;
              handleInputChange('ingredients', updatedIngredients);
            }}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={4}>
          <Select
            fullWidth
            value={ingredient.unit}
            onChange={(e) => {
              const updatedIngredients = [...postData.ingredients];
              updatedIngredients[index].unit = e.target.value;
              handleInputChange('ingredients', updatedIngredients);
            }}
            displayEmpty
          >
            <MenuItem value=""><em>Select Unit</em></MenuItem>
            <MenuItem value="grams">Grams</MenuItem>
            <MenuItem value="kg">Kg</MenuItem>
            <MenuItem value="pieces">Pieces</MenuItem>
            <MenuItem value="tablespoon">Tablespoon</MenuItem>
            <MenuItem value="teaspoon">Teaspoon</MenuItem>
          </Select>
        </Grid>
      </Grid>
    ))}
    <Button className='unit-btn active' onClick={addIngredient} sx={{ marginBottom: '2rem' }}>Add Ingredient</Button>

    {/* Instructions Section */}
    <Typography variant="h5" gutterBottom>Instructions</Typography>
    <List>
      {postData.instructions.map((instruction, index) => (
        <ListItem key={index}>
          <TextField
            fullWidth
            label={`Step ${index + 1}`}
            value={instruction}
            onChange={(e) => {
              const updatedInstructions = [...postData.instructions];
              updatedInstructions[index] = e.target.value;
              handleInputChange('instructions', updatedInstructions);
            }}
            variant="outlined"
          />
        </ListItem>
      ))}
    </List>
    <Button className='unit-btn' onClick={addInstruction} sx={{ marginBottom: '2rem' }}>Add Instruction</Button>

    {/* Notes Section */}
    <Typography variant="h5" gutterBottom>Notes</Typography>
    <List>
      {postData.notes.map((note, index) => (
        <ListItem key={index}>
          <TextField
            fullWidth
            label={`Note ${index + 1}`}
            value={note}
            onChange={(e) => {
              const updatedNotes = [...postData.notes];
              updatedNotes[index] = e.target.value;
              handleInputChange('notes', updatedNotes);
            }}
            variant="outlined"
          />
        </ListItem>
      ))}
    </List>
    <Button className='unit-btn active' onClick={addNote} sx={{ marginBottom: '2rem' }}>Add Note</Button>

    {/* Additional Info Section */}
    <Typography variant="h5" gutterBottom>Additional Info</Typography>
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Prep Time"
          value={postData.additionalInfo.prepTime}
          onChange={(e) => handleNestedChange('additionalInfo', 'prepTime', e.target.value)}
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="end">Minutes</InputAdornment>
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Cook Time"
          value={postData.additionalInfo.cookTime}
          onChange={(e) => handleNestedChange('additionalInfo', 'cookTime', e.target.value)}
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="end">Minutes</InputAdornment>
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Servings"
          value={postData.additionalInfo.serving}
          onChange={(e) => handleNestedChange('additionalInfo', 'serving', e.target.value)}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="Category"
          value={postData.additionalInfo.category}
          onChange={(e) => handleNestedChange('additionalInfo', 'category', e.target.value)}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Cook Method"
          value={postData.additionalInfo.method}
          onChange={(e) => handleNestedChange('additionalInfo', 'method', e.target.value)}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Cuisine"
          value={postData.additionalInfo.cuisine}
          onChange={(e) => handleNestedChange('additionalInfo', 'cuisine', e.target.value)}
          variant="outlined"
        />
      </Grid>
    </Grid>
  </>
)}




        <button  disabled={uploading} style={{ marginTop: '5px' }}>Update Post</button>
        <Button
        disabled={uploading}
          variant="outlined"
          color="error"
          onClick={handleOpenDeleteDialog}
          sx={{ marginTop: '10px' }}
        >
          Delete Post
        </Button>
     
      </form>

        {/* Delete Confirmation Dialog */}
        <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
      >
        <DialogTitle>{"Delete Post"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this post? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={deletePost} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
